export enum StoredCreditSource {
  Client = "client",
  Exchange = "exchange",
  ExchangeStock = "exchange_stock",
}
